import { render } from "./TooltipPage.vue?vue&type=template&id=97185f94"
import script from "./TooltipPage.vue?vue&type=script&lang=js"
export * from "./TooltipPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__